const LoggedOut = ({ children }) => {
  return <div className="h-screen w-full">{children}</div>;
};

export default LoggedOut;
